export default __webpack_public_path__ + "static/designrush-cover-007520b9cfc8ac4ff4cb725dd0e263dd.png";